import Win from './Window';
import { GetBy } from '../core/Element';
import { gsap, Power3 } from 'gsap';

class WinIframe extends Win {
  _iframe;
  _src;

  constructor(__container) {
    super(__container, 'iframe');
    this._iframe = GetBy.selector('iframe', this.container)[0];
    this._src = this._iframe?.getAttribute('data-src') || '';
    this.directHide();
  }

  show(__d = 0) {
    if (this._iframe && this._src) this._iframe.src = this._src;
    super.show(__d);
  }

  show__effect(__d = 0) {
    gsap.to(this.container, {
      alpha: 1,
      y: 0,
      duration: 0.4,
      ease: Power3.easeOut,
      onComplete: () => { this.afterShow(); },
    });
  }

  hide__effect(__d = 0) {
    gsap.to(this.container, {
      alpha: 0,
      y: 0,
      duration: 0.4,
      ease: Power3.easeOut,
      onComplete: () => { this.afterHide(); },
    });
  }

  afterHide() {
    if (this._iframe) {
      this._iframe.src = 'about:blank';
      this._iframe.removeAttribute('src');
    }
    super.afterHide();
  }

  directHide() {
    gsap.set(this.container, { y: 0, alpha: 0 });
    super.directHide();
  }
}

export const WinIframeCalendar = new WinIframe(GetBy.id('IframeCalendar'));
